import { InputAdornment, TextField } from '@mui/material';
import strings from 'common/Translation/Translate';

interface SplitPercentTextBoxProps {
  item: any;
  setPageResponse: any;
  isDisabled: boolean;
}

const SplitPercentTextBox = ({ item, setPageResponse, isDisabled }: SplitPercentTextBoxProps) => {
  const raw = item.splitRevenuePercent;
  const display = raw === null || raw === undefined ? '' : String(raw);
  const numeric = display === '' ? null : Number(display);
  const invalid =
    display !== '' && (numeric == null || Number.isNaN(numeric) || numeric < 0 || numeric > 100);

  const helperText = () => {
    if (display === '') return '';
    if (numeric != null && numeric < 0) return strings.lessThaZeroError;
    if (numeric != null && numeric > 100) return strings.greaterThan100Error;
    return '';
  };

  return (
    <TextField
      size="small"
      required
      value={display}
      type="text"
      disabled={isDisabled}
      error={invalid}
      onChange={e => {
        const v = e.target.value;
        if (v !== '' && Number.isNaN(Number(v))) return;
        setPageResponse((prev: any[]) =>
          prev.map(row => (row.id === item.id ? { ...row, splitRevenuePercent: v } : row)),
        );
      }}
      helperText={helperText()}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ '& .MuiTypography-root': { fontSize: 13 } }}>
            %
          </InputAdornment>
        ),
      }}
      inputProps={{ inputMode: 'decimal', style: { textAlign: 'right' } }}
      sx={{ width: 112, '& .MuiFormHelperText-root': { mx: 0 } }}
    />
  );
};

export default SplitPercentTextBox;
